import { ScrollArea, Text } from "@mantine/core";
import { Button } from "src/components/shared/Button/Button";
import { type IGroupOrLabel } from "src/interfaces";
import { Flex, SectionDivider } from "src/styled";

import { useGroupContext } from "../GroupContext";
import GroupItem from "./GroupItem/GroupItem";
interface Props {
  elements: IGroupOrLabel[];
}
const GroupsList = ({ elements }: Props) => {
  const { handleAddElement, addButtonLabel, elementsSection } =
    useGroupContext();

  const renderGroups = () => {
    if (elements.length > 0) {
      return elements.map(el => <GroupItem key={el.groupId} group={el} />);
    } else {
      return (
        <>
          <Text fz={32} c="gray.5" ta="center" fw="bold">
            {elementsSection.emptyMessage}
          </Text>
          <Button variant="filled" onClick={handleAddElement}>
            {addButtonLabel}
          </Button>
        </>
      );
    }
  };

  return (
    <Flex flex={1.5} direction="column" gap={30}>
      <SectionDivider>{elementsSection.title}</SectionDivider>
      <ScrollArea
        type="auto"
        w="80%"
        style={{ height: "calc(100vh - 104px - 250px)" }}>
        <Flex direction="column" gap={20}>
          {renderGroups()}
        </Flex>
      </ScrollArea>
    </Flex>
  );
};

export default GroupsList;
